import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DialogModule } from 'primeng';
import { OrderBookingHealthCheckService } from '../../../services/order-booking-health-check.service';
import { IOrderBookingCheckInfo } from '../../../interfaces/order-booking-health-check/order-booking-check-info';

@Component({
  selector: 'order-booking-check-info',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule],
  template: `
    <button
      pButton
      type="button"
      icon="fa fa-info-circle"
      label="What each check does"
      class="ui-button-secondary"
      (click)="open()"
    ></button>

    <p-dialog
      header="What each check does"
      [(visible)]="showDialog"
      [modal]="true"
      [style]="{ width: '620px' }"
    >
      <div style="max-height: 60vh; overflow-y: auto">
        <div *ngFor="let check of checks" class="mb-3">
          <div class="bold-text">{{ check.title }}</div>
          <div class="text-gray-600">{{ check.description }}</div>
        </div>
      </div>
    </p-dialog>
  `,
})
export class OrderBookingCheckInfoComponent {
  protected checks: IOrderBookingCheckInfo[] = [];
  protected showDialog = false;

  constructor(private orderBookingHealthCheckService: OrderBookingHealthCheckService) {}

  // Loaded on first open rather than with the page, since most visits never ask for it. The wording
  // comes from the seeded checks, so it matches what the issue itself says.
  protected async open() {
    if (!this.checks.length) {
      this.checks = (await this.orderBookingHealthCheckService.getChecks()) ?? [];
    }

    this.showDialog = true;
  }
}
